import { scheduleExport } from '../../store/actions/export'
import { referenceLoadAudience, referenceLoadPageData } from '../../store/actions/references'
import { scheduleLoad } from '../../store/actions/schedule'
import { exportActions } from '../../store/slices/export'
import { scheduleActions } from '../../store/slices/schedule'
import { schedulePageActions } from '../../store/slices/schedulePage'

export const schedulePageStoreActions = {
    scheduleLoad,
    referenceLoadPageData,
    referenceLoadAudience,
    scheduleExport,
    resetSchedule: scheduleActions.resetSchedule,
    resetExportNotice: exportActions.resetNotice,
    ...schedulePageActions,
}

export const scheduleExportActions = {
    scheduleExport,
    resetExportNotice: exportActions.resetNotice,
    setExportGroup: schedulePageActions.setExportGroup,
    setExportModalOpen: schedulePageActions.setExportModalOpen,
    setSaveOnServer: schedulePageActions.setSaveOnServer,
}

export const scheduleFiltersActions = {
    resetSchedule: scheduleActions.resetSchedule,
    referenceLoadAudience,
    setDateRange: schedulePageActions.setDateRange,
    clearDateFilter: schedulePageActions.clearDateFilter,
    setViewMode: schedulePageActions.setViewMode,
    setSelectedGroupId: schedulePageActions.setSelectedGroupId,
    setSelectedTeacherId: schedulePageActions.setSelectedTeacherId,
    setSelectedBuildId: schedulePageActions.setSelectedBuildId,
    setSelectedRoomId: schedulePageActions.setSelectedRoomId,
    setSelectedClassTypeId: schedulePageActions.setSelectedClassTypeId,
    setSelectedSubjectId: schedulePageActions.setSelectedSubjectId,
    resetFilters: schedulePageActions.resetFilters,
    toggleShowMoreOptions: schedulePageActions.toggleShowMoreOptions,
}

export const scheduleListActions = {
    setPagination: schedulePageActions.setPagination,
}

export const scheduleEffectsActions = {
    scheduleLoad,
    referenceLoadPageData,
    setSelectedGroupId: schedulePageActions.setSelectedGroupId,
    setSelectedTeacherId: schedulePageActions.setSelectedTeacherId,
}
